export const KB_CONTENT_ROUTES = '(presentation|test|quiz|sandbox_test|file)'
